export function cleanupCalculatorSession(): void {
  sessionStorage.removeItem("mem_calc_tab");
}
